export const labelBeagleHistoryCard =
    {
        "labelNutrient": {
            "en": "Nutrient",
            "es": "Nutriente",
            "fr": "Elément nutritif",
            "pt": "Nutriente",
            "ru": "Элемент питания",
            "zh": "养分类型"
        },
        "labelRemoval": {
            "en": "Removal",
            "es": "Remoción",
            "fr": "Exportations",
            "pt": "Remoção",
            "ru": "Вынос",
            "zh": "移除部分"
        },
        "labelClearButton": {
            "en": "Clear",
            "es": "Clara",
            "fr": "Clair",
            "pt": "Clara",
            "ru": "Очистить",
            "zh": "明确"
        },
        "labelCopyToClipboardButton": {
            "en": "copy to clipboard",
            "es": "copiar al portapapeles",
            "fr": "copier dans le presse-papier",
            "pt": "copiar para área de transferência",
            "ru": "скопировать в буфер обмена",
            "zh": "copy to clipboard"
        },
        "labelCopyToClipboardSnackBar": {
            "en": "Information copied to the clipboard.",
            "es": "Información copiada al portapapeles.",
            "fr": "Informations copiées dans le presse-papiers.",
            "pt": "Informações copiadas para a área de transferência.",
            "ru": "Информация скопирована в буфер обмена.",
            "zh": "Information copied to the clipboard."
        }
    };
